<template>
  <div
    class="eggs-dialog-component"
    :class="{'eggs-dialog-show': visible}"
  >
    <div
      class="eggs-content"
      :style="{backgroundImage: 'url('+ bgUrl +')'}"
    >
      <img
        class="eggs-close"
        src="@/assets/images/order/eggs-close.png"
        @click="goToOrderList"
      />
    </div>
  </div>
</template>

<script>
import BG from '@/assets/images/order/eggs-bg.jpg'

export default {
  props: {
    visible: {
      type: Boolean,
      default: false
    },
    url: {
      type: String,
      default: ''
    },
    from: {
      type: String,
      default: ''
    }
  },
  data() {
    return {
      bg: ''
    }
  },
  computed: {
    bgUrl() {
      return this.url || this.bg
    }
  },
  created() {
    this.bg = BG
  },
  methods: {
    closeDialog() {
      this.$emit('update:visible', false)
    },
    goToOrderList() {
      if (this.from === 'payResult') {
        this.closeDialog()
        return
      }
      this.$router.push({
        path: '/order/list'
      })
    }
  }
}
</script>

<style lang="less" scoped>
.eggs-dialog-component {
  display: none;
  position: fixed;
  left: 0;
  right: 0;
  top: 0;
  bottom: 0;
  z-index: 20000;
  .eggs-content {
    position: absolute;
    height: 480px;
    width: 558px;
    left: 50%;
    top: 50%;
    margin-left: -279px;
    margin-top: -240px;
    background: url("../../../assets/images/order/eggs-bg.jpg") no-repeat;
    .eggs-close {
      height: 32px;
      width: 32px;
      cursor: pointer;
      position: absolute;
      right: -32px;
      top: -32px;
    }
  }
  &.eggs-dialog-show {
    display: block;
  }
}
</style>
